import { SETTABLE, TABLE_ERROR, REMOVETABLE, WAITER_CALLED, SET_CONTINUE_ORDERING } from "../actionTypes";
import axios from './axios';

export const setTable = (table) => async (dispatch, getState) => {

    const state = getState();
    const token = state.user.token;
    const res = await axios.post("table/get", {
        merchant_id: state.restaurant.merchant_id,
        table: table,
        client_token: token
    })
    if (res.data.code == 1) {
        localStorage.setItem("table_number", table);
        dispatch({
            type: SETTABLE,
            payload: table
        })
        dispatch({
            type: TABLE_ERROR,
            payload: ""
        })
        localStorage.setItem("isContinueOrder", res.data.details.is_continue_ordering);
        dispatch({
            type: SET_CONTINUE_ORDERING,
            payload: res.data.details.is_continue_ordering
        })
    }

    if (res.data.code == 2) {
        dispatch({
            type: TABLE_ERROR,
            payload: res.data.msg
        })
    }

}


export const removeTable = () => {
    localStorage.removeItem("table_number");
    return {
        type: REMOVETABLE
    }
}


export const callWaiter = () => async (dispatch, getState) => {
    const state = getState();
    const token = state.user.token;
    const table = state.table.table;
    const mainOrderId = state.cart.orderid;
    const res = await axios.post("table/callwaiter", {
        merchant_id: state.restaurant.merchant_id,
        table: table,
        order_id: mainOrderId,
        client_token: token
    })

}


export const waiterCalled = () => {
    localStorage.setItem("iswaitercalled", 1);
    return {
        type: WAITER_CALLED,
        payload: true
    }
}